import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat, Tanggal } from '../../function/Format';

const ModalSuratKematian = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: "",
		agama: "",
		alamat: "",
		id_jenis: "",
		jenis_kelamin: "",
		kewarganegaraan: "Indonesia",
		kk: "",
		nik: "",
		nama: "",
		pekerjaan: "",
		pendidikan_terakhir: "",
		status_perkawinan: "",
		tanggal_lahir: "",
		tempat_lahir: "",

		nik_pelapor: "",
		nama_pelapor: "",
		tanggal_lahir_pelapor: "",
		jenis_kelamin_pelapor: "",
		status_perkawinan_pelapor: "",
		pekerjaan_pelapor: "",
		agama_pelapor: "",
		alamat_pelapor: "",
		hubungan_pelapor: null,

		//detail
		waktu_meninggal: null,
		tempat_meninggal: '',
		sebab_meninggal: '',
		tempat_makam: '',
	};

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmShdk: optionData.frmShdk,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		nikStat: null,
		nik2Stat: null,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			dataPenduduk2: "none",
			frmPreviewDraft: false,
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			frmNik: optionData.frmNik,
			frmNik2: optionData.frmNik2,
			frmShdk: optionData.frmShdk,
			nikStat: optionData.nikStat,
			nik2Stat: optionData.nik2Stat,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false || e && fld == "nik") {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;
					case "nik2":
						setFormData({
							...formData,
							frmNik2: frmNik,
							tmplistPenduduk3: tmplistPenduduk,
							nik2Stat: nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeSelectValue = (e, sel) => {
		switch (sel) {
			case "jk":
				setDt({
					...dt,
					jk: e.value
				})
				setFormData({
					...formData,
					jkkkStat: e
				})
				// this.setState({
				// 	jkkkStat: e,
				// 	dt: {
				// 		...this.state.dt,
				// 		jk: e.value,
				// 	},
				// });

				// // For testing
				// if (this.props.selectOnChangeJenisKelaminPasangan) {
				// 	this.props.selectOnChangeJenisKelaminPasangan(e)
				// }
				break;
			case "agama":
				setDt({
					...dt,
					agama_pasangan: e.value
				})
				setFormData({
					...formData,
					agmStat: e
				})
				break;
			case "pekerjaan_pasangan":
				setDt({
					...dt,
					pekerjaan_pasangan: e
				})
				break;
			default:
				// no default
				break;
		}
	}

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const gantiTgl = (date, fld) => {
		if (typeof date._isValid !== 'undefined') {
			let tgl = date.format('YYYY-MM-DD HH:mm');
			setDt({
				...dt,
				[fld]: new Date(tgl)
			})
		}
	}

  const getPenduduk = (e, jns) => {
    if (e) {
		if (kioskMode) {
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}

			Get("penduduk/find", e.value, data => {
				if(data.results){
					const alamat = generateAlamat(data.results);
					let alamat_kk = "";
			
					if(data.results.data_kk){
					  alamat_kk = data.results.data_kk.alamat
					}
					
					if (jns === "nik") {
						// pelapor
						setFormData({
							...formData,
							nikStat: e,
							status: {
								...formData.status,
								dataPenduduk: "block"
							}
						});
      
						setDt({
							...dt,
							nik: data.results.id,
							nik_pelapor: data.results.id,
							kk: data.results.id_kk,
							nama: data.results.nama,
							nama_pemohon: data.results.nama,
							tempat_lahir: data.results.tempat_lahir,
							tanggal_lahir: new Date(
								data.results.tanggal_lahir
							),
							pekerjaan: data.results.data_pekerjaan.nama,
							pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
							agama: data.results.data_agama.nama,
							status_perkawinan: data.results.status_perkawinan,
							jenis_kelamin: data.results.jk,
							alamat: alamat,
							alamat_kk: alamat_kk,
							kewarganegaraan: 'WNI',
						})

						if (kioskMode) {
							props.setLoadingPreview(false)
						}
						else{
							setAlert({
								loadingPreview: false
							})
						}
					}
          			else if (jns === "nik2") {
						setFormData({
							...formData,
							nik2Stat: e,
							status: {
								...formData.status,
								dataPenduduk2: "block",
							},
						})
						setDt({
							...dt,
							nik_pelapor: data.results.id,
							nama_pelapor: data.results.nama,
							tempat_lahir_pelapor: data.results.tempat_lahir,
							tanggal_lahir_pelapor: data.results.tanggal_lahir,
							jenis_kelamin_pelapor: data.results.jk,
							status_perkawinan_pelapor: data.results.status_perkawinan,
							pekerjaan_pelapor: data.results.data_pekerjaan.nama,
							agama_pelapor: data.results.data_agama.nama,
							alamat_pelapor: alamat,
							alamat_kk_pelapor: alamat_kk,
						})

						if (kioskMode) {
							props.setLoadingPreview(false)
						}
						else{
							setAlert({
								loadingPreview: false
							})
						}
					}

				}
				else{
					if (kioskMode) {
						props.setLoadingPreview(false)
					}
					else{
						setAlert({
							loadingPreview: false
						})
					}
				}
			})
    } else {
      switch (jns) {
        case "nik":
			setDt({
				...dt,
				nik: "",
				nik_pelapor: "",
				kk: "",
				nama_pemohon: "",
				tempat_lahir: "",
				tanggal_lahir: null,
				pekerjaan: "",
				pendidikan_terakhir: "",
				agama: "",
				status_perkawinan: "",
				jenis_kelamin: "",
				alamat: "",
				alamat_kk: "",
				kewarganegaraan: ""
			});
			setFormData({
				...formData,
				status: {
					...formData.status,
					dataPenduduk: "none"
				},
				nikStat: null
			});
          break;
        case "nik2":
			setDt({
				...dt,
				nik_pelapor: "",
				nama_pelapor: "",
				tempat_lahir_pelapor: "",
				tanggal_lahir_pelapor: "",
				jenis_kelamin_pelapor: "",
				status_perkawinan_pelapor: "",
				pekerjaan_pelapor: "",
				agama_pelapor: "",
				alamat_pelapor: "",
			});
			setFormData({
				...formData,
				nik2Stat: null,
				status: {
					...formData.status,
					dataPenduduk2: "none",
				},
          });
          break;
        default:
          break;
      }
    }
  };


	const simpan = (e) => {
		e.preventDefault();

		if (kioskMode){
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}

		let validasiWarga = false;
		let validasiPelapor = false;

		// validasi warga
		if (formData.nikStat != null) {
			validasiWarga = true;
		}
		// validasi pelapor
		if (formData.nik2Stat !== null) {
			validasiPelapor = true;
		}

		if (validasiWarga && validasiPelapor && dt.hubungan_pelapor) {
			if (kioskMode) {
				props.setLoadingPreview(true)
			}

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(dt.tanggal_lahir, 'yyyy-mm-dd'),
				tanggal_lahir_pelapor: dateFormat(dt.tanggal_lahir_pelapor, 'yyyy-mm-dd'),
				hubungan_pelapor: dt.hubungan_pelapor.value,
				waktu_meninggal: dateFormat(dt.waktu_meninggal, 'yyyy-mm-dd HH:MM'),
				alamat: dt.alamat,
				alamat_kk: dt.alamat_kk,

				alamat_pelapor: dt.alamat_pelapor,
				alamat_kk_pelapor: dt.alamat_kk_pelapor,
				// tujuan_pembuatan: "Surat Keterangan kematian",
				// detail: formDetail
			};

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			// if (bodyRaw.detail.length > 0) {
			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			Post(
				"surat-keterangan/kematian/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					// Kalau mode kiosk
					if (kioskMode) {
						if (res.status === resstat) {
							let dataAntrian = {
								nama: props.data.results.nama,
								nik: props.data.results.id,
								keterangan: '',
								uuid_surat:res.data.results.uuid_surat,
								kode_surat:res.data.results.kode_surat,
							};

							// Set Data Surat
							props.getDataSurat(res.data.results);
  
							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {

									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Keterangan Kematian', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Keterangan Kematian', 'gagal');
									}
								});
							}.bind(this),1000)
						}
						else{
							props.setLoadingPreview(false)
							props.getAntrian('Surat Keterangan Kematian', 'gagal');
						}

					} else { // Kalau bukan kiosk
						if (res.status === resstat) {
							const alertData = {
								get_data_surat:{
									uuid_surat:res.data.results.uuid_surat,
									kode_surat:res.data.results.kode_surat,
								},
								status:{
									frmPreviewDraft: true,
									jenis_form: psn,
								}
								// show: true,
								// basicType: "success",
								// basicTitle: "Data Surat Keterangan Kematian",
								// pesanAlert: "Berhasil " + psn + " Data",
								// successAlert: true
							};
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData);
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Keterangan Kematian",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}
				}
			);
			// }

		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Kematian', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					  loadingPreview: false
				})
				setAlert(alertData)
			}
		}

	};

	return (
		<Modal
			// classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: "80%", maxwidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form mt-3"
				style={{
          maxwidth: "unset",
          width: '100%',
				}}
				onSubmit={simpan}
			>
				{/* <div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				> */}
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Keterangan Kematian</h5>
					</div>
					<div className="modal-body">
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>
						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Pelapor</b>
						</div>

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK Pelapor
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik2");
										}}
										defaultValue={formData.nik2Stat}
										value={formData.nik2Stat}
										name="penduduk"
										onInputChange={e => handleInputChangeNIK(e, "nik2")}
										options={formData.frmNik2}
										placeholder="Pilih NIK Pelapor"
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.dataPenduduk2 }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pelapor
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pelapor"
										type="text"
										placeholder="Nama Pelapor"
										value={dt.nama_pelapor}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tempat_lahir_pelapor"
										type="text"
										placeholder="Tempat Lahir Pelapor"
										value={dt.tempat_lahir_pelapor}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir_pelapor"
										type="text"
										placeholder="Tanggal Lahir Pelapor"
										value={new Date(dt.tanggal_lahir_pelapor).toLocaleDateString("id-ID")}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Alamat
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="alamat_kk_pelapor"
										type="text"
										placeholder="Alamat"
										value={dt.alamat_kk_pelapor}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Wilayah
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="alamat_pelapor"
										type="text"
										placeholder="alamat"
										value={dt.alamat_pelapor}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
								</Col>
							</FormGroup>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="shdk"
							>
								Hubungan Pelapor
							</Label>
							<Col sm="9">
								<div data-testid="selectShdk">
									<Select
										inputId="shdk"
										name="shdk"
										classNamePrefix="select"
										onChange={(e) => {
											// this.changeSelectValue(e, 'shdk');
											setDt({
												...dt,
												hubungan_pelapor: e
											})
										}}
										initialValue={dt.hubungan_pelapor}
										value={dt.hubungan_pelapor}
										id="shdk"
										options={formData.frmShdk}
										// options={[
										// 	{ value: 'Suami', label: 'Suami' },
										// 	{ value: 'Isteri', label: 'Isteri' },
										// 	{ value: 'Orang Tua', label: 'Orang Tua' },
										// 	{ value: 'Anak', label: 'Anak' },
										// 	{ value: 'Kakak', label: 'Kakak' },
										// 	{ value: 'Adik', label: 'Adik' },
										// 	{ value: 'Mertua', label: 'Mertua' },
										// 	{ value: 'Menantu', label: 'Menantu' },
										// 	{ value: 'Cucu', label: 'Cucu' },
										// 	{ value: 'Pembantu', label: 'Pembantu' },
										// 	{ value: 'Famili Lain', label: 'Famili Lain' }
										// ]}
										placeholder="Pilih Hubungan Keluarga"
									/>
								</div>
							</Col>
						</FormGroup>

						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Penduduk Meninggal</b>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK Warga
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik");
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										name="penduduk"
										onInputChange={e => handleInputChangeNIK(e, "nik")}
										options={formData.frmNik}
										placeholder="Pilih NIK Warga yang Meninggal"
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div
							style={{ display: formData.status.dataPenduduk }}
						>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pemohon"
										readOnly
										type="text"
										placeholder="Nama Pemohon"
										value={dt.nama_pemohon}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										readOnly
										id="tempat_lahir"
										type="text"
										placeholder="Tempat lahir"
										value={dt.tempat_lahir}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										readOnly
										type="text"
										placeholder="Tanggal Lahir"
										value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Alamat
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="alamat_kk"
										type="text"
										placeholder="Alamat"
										value={dt.alamat_kk}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Wilayah
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="alamat"
										type="text"
										placeholder="alamat"
										value={dt.alamat}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
								</Col>
							</FormGroup>
						</div>
						<hr />

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="waktu_meninggal"
							>
								Waktu Meninggal
							</Label>
							<Col sm="9">
								<Datetime
									inputProps={{ "data-testid": "waktu_meninggal", placeholder: 'Waktu Meninggal', required: true }}
									inputId="waktu_meninggal"
									name="waktu_meninggal"
									locale="id-ID"
									timeFormat="HH:mm"
									dateFormat="DD/MM/yyyy"
									input={true}
									closeOnTab={true}
									initialValue={dt.waktu_meninggal}
									value={dt.waktu_meninggal}
									onChange={e => {
										gantiTgl(e, "waktu_meninggal");
									}}
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tempat Meninggal
							</Label>
							<Col sm="9">
								<input
									data-testid="tempat meninggal"
									name="tempat_meninggal"
									className="form-control"
									id="tempat_meninggal"
									type="text"
									placeholder="Tempat Meninggal"
									defaultValue={dt.tempat_meninggal}
									onChange={e => changeInputText(e, "tempat_meninggal")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Sebab Meninggal
							</Label>
							<Col sm="9">
								<input
									data-testid="sebab meninggal"
									name="sebab_meninggal"
									className="form-control"
									id="sebab_meninggal"
									type="text"
									placeholder="Sebab Meninggal"
									defaultValue={dt.sebab_meninggal}
									value={dt.sebab_meninggal}
									onChange={e => changeInputText(e, "sebab_meninggal")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Dimakamkan di
							</Label>
							<Col sm="9">
								<input
									data-testid="tempat makam"
									name="tempat_makam"
									className="form-control"
									id="tempat_makam"
									type="text"
									placeholder="Tempat Makam"
									defaultValue={dt.tempat_makam}
									value={dt.tempat_makam}
									onChange={e => changeInputText(e, "tempat_makam")}
									required
								/>
							</Col>
						</FormGroup>
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false,
                    frmPreviewDraft: false,
					          jenis_form: '',
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
						// disabled={formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				{/* </div> */}
			</Form>
		</Modal>
	);
}

export default ModalSuratKematian;
